import React, { useEffect, useRef, useState } from "react";
import { BiHome, BiMenu, BiUser } from "react-icons/bi";
import {
  FaClipboardList,
  FaHeart,
  FaRegHeart,
  FaRegUser,
  FaShoppingCart,
} from "react-icons/fa";
import { FaCodeCompare, FaShop } from "react-icons/fa6";
import { FiSearch } from "react-icons/fi";
import { RiShoppingCartLine } from "react-icons/ri";
import { Link, useLocation, useNavigate } from "react-router-dom";
// import { categories as catelog } from "../data/category";
import SideBar from "./SideBar";
import { getALLCategory, getAllProducts } from "../apis/config";
import { useSelector } from "react-redux";
import { BsShop } from "react-icons/bs";
import { GrClose, GrCompare } from "react-icons/gr";
import Logo from '../data/logo_01.png'
import { useAuth } from "../context/AuthProvider";

const Header = () => {
  const {user} = useAuth()
  const [activeLink, setActiveLink] = useState("");
  const [catView, setCatView] = useState(false);
  const [activeCategoryIndex, setActiveCategoryIndex] = useState(0);
  const [searchOpen, setSearchOpen] = useState(true);
  const [menuOpen, setMenuOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [categorys,setCategorys] = useState([])
  const [subCategories,setSubCategories] = useState([])
  const [products,setProducts] = useState([])
  const location = useLocation();
  const navigate = useNavigate();
  const cart = useSelector(state=>state.cart.cart)
  const searchRef = useRef(null);


  useEffect(() => {
    setActiveLink(location.pathname);
  }, [location]);

  const handleLinkClick = (href) => {
    setActiveLink(href);
  };

  const menuItems = [
    {
      name: "Home",
      href: "/",
      icon: <BiHome className="w-6 h-6" />,
    },
    {
      name: "Cart",
      href: "/cart",
      icon: <FaShoppingCart className="w-6 h-6" />,
    },
    {
      name: "Shop",
      href: "/shop",
      icon: <FaShop className="w-6 h-6" />,
    },
    {
      name: "Profile",
      href: "/account",
      icon: <BiUser className="w-6 h-6" />,
    },
    {
      name: "Wish",
      href: "/wishlist",
      icon: <FaHeart className="w-6 h-6" />,
    },
  ];

  const categories = categorys.map(cate=>cate.name)
  const searchItems = searchQuery
    ? products.filter((pro) => {
        const query = searchQuery.trim().toLowerCase();
        const nameMatch = pro.name.toLowerCase().includes(query);
        const tagsMatch = pro.tags?.some(tag =>
          tag.toLowerCase().includes(query)
        );
        return nameMatch || tagsMatch;
      })
    : [];

  const wishLists = useSelector(state=>state.wish.wish)

  const compares = useSelector(state=>state.compare.compare)
  
  useEffect(()=>{
    getALLCategory().then(res=>setCategorys(res.data)).catch(err=>console.log(err))
    getAllProducts().then(res=>setProducts(res.data)).catch(err=>console.log(err))
  },[])


  useEffect(()=>{
    const data = categorys.find(cate=>cate?.name?.toLowerCase() === categories[activeCategoryIndex]?.toLowerCase())
    // console.log(activeCategoryIndex)
    setSubCategories(data?.subcategories)
  },[activeCategoryIndex])

  const chunkArray = (array, chunkSize) => {
  const chunks = [];
    for (let i = 0; i < array.length; i += chunkSize) {
      chunks.push(array.slice(i, i + chunkSize));
    }
    return chunks;
  };

  return (
    <>
      <header className="w-full flex justify-between items-center px-5 py-2 sm:px-10 relative">
        <div className="  hover:text-primary hover:scale-150 duration-200 ease-in md:hidden" onClick={()=>setMenuOpen(!menuOpen)}>
          <BiMenu size={30}/>
        </div>
        <div className=" w-28 h-20 flex justify-center mx-auto sm:mx-0 items-center ">
          <Link to='/'>
          <img src={Logo} alt="logo" className=" w-full h-auto" />
          </Link>
        </div>
        <nav>
          <ul className=" flex justify-center items-center text-[16px] cursor-pointer gap-5 text-gray-700">
            {/* <li className="  hover:text-primary duration-200 ease-in hidden sm:block">
              <Link to="/">Home</Link>
            </li>
            <li className="  hover:text-primary duration-200 ease-in hidden sm:block">
              <Link to="/shop">Shop</Link>
            </li> */}
            {/* <li
              className="  hover:text-primary  duration-200 ease-in hidden sm:block "
              onClick={() => setCatView(true)}
              onMouseEnter={() => setCatView(true)}
              // onMouseLeave={() => setCatView(false)}
              onTouchStart={() => setCatView((prev) => !prev)}
            >
              Category
            </li>
            <li className="  hover:text-primary  duration-200 ease-in hidden sm:block">
              <Link to="/about">About</Link>
            </li>
            <li className="  hover:text-primary  duration-200 ease-in hidden sm:block">
              <Link to="/contact">Contact Us</Link>
            </li> */}
          </ul>
        </nav>
        <nav className=" relative">
          <ul className=" flex justify-center items-center text-[22px] cursor-pointer gap-5 text-gray-700">
          {searchOpen && (
              <div ref={searchRef} className=" hidden w-full md:flex md:w-[300px] flex-col justify-center items-center relative px-4 py-4 z-50 md:bg-white">
                <input
                  type="text"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  placeholder="Search products..."
                  className="w-full p-2 border text-[12px] rounded-md focus:outline-none focus:ring-2 focus:ring-primary mb-2"
                />
               {searchQuery && <ul className=" flex flex-col absolute gap-2 bg-white w-[300px] max-h-[400px] overflow-y-auto shadow-md p-2 top-16">
                  {searchItems.length ? searchItems.map((d,i)=>(
                    <li key={i}>
                      <div className=" flex gap-2 bg-gray-100 p-2 rounded-md" onClick={()=>{
                        navigate(`/products/${d._id}`)
                        setSearchQuery("")
                        }}>
                        <div className=" w-10 h-10"><img src={d.images[0]} alt={i} className=" w-full h-full" /></div>
                        <div>
                        <h3 className=" text-[12px]">{d.name}</h3>
                        <h5 className=" text-[10px] font-semibold text-red-600">&#8377; {d.salePrice}</h5>
                        </div>
                      </div>
                    </li>)
                  ):<li className=" text-[12px] w-full">No products found</li>}
                </ul>}
              </div>
            )}
            {/* <li className="  hover:text-primary hover:scale-150 duration-200 ease-in md:hidden" onClick={() => setSearchOpen((prev) => !prev)}>
              <FiSearch />
              
            </li> */}
            <li className={`${user ? "" : " hover:scale-150"} hover:text-primary duration-200 ease-in hidden sm:block`}>

              <Link to="/account" className=" flex gap-2 justify-center items-center" title="Profile">
                <FaRegUser /> {user?.name && <span className=" text-sm"> Hi, <span className=" text-primary">{user?.name}</span></span>}
              </Link>
            </li>
            <li className="  hover:text-primary hover:scale-150 duration-200 ease-in hidden  sm:block">
              <Link to="/shop" title="Shop">
                <BsShop />
              </Link>
            </li>
            <li className="  hover:text-primary  hover:scale-150 duration-200 ease-in hidden sm:block relative">
              <Link to="/wishlist" title="Wishlist">
                <FaRegHeart />
              </Link>
              {wishLists?.length > 0 &&<span className=" absolute text-center rounded-full w-2 h-2 -top-1 -right-2 bg-red-600 text-white text-[10px]">
              </span>}
            </li>
            <li className="  hover:text-primary relative hover:scale-150 duration-200 ease-in">
              <Link to="/cart" title="Cart">
                <RiShoppingCartLine />
              </Link>
              <span className=" absolute text-center rounded-full w-4 h-4 -top-2 -right-3 bg-primary text-white text-[10px]">
                {cart.length}
              </span>
            </li>
          </ul>
         
        </nav>
        
      </header>
       {searchOpen && (
              <div ref={searchRef} className=" w-full md:hidden md:w-[300px] flex-col justify-center items-center relative px-4 z-50 md:bg-white">
                <input
                  type="text"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  placeholder="Search products..."
                  className="w-full p-2 border text-[12px] rounded-md focus:outline-none focus:ring-2 focus:ring-primary mb-2"
                />
               {searchQuery && <ul className=" flex flex-col absolute gap-2 bg-white w-[90%] max-h-[400px] overflow-y-auto shadow-md p-2 top-12 ">
                  {searchItems.length ? searchItems.map((d,i)=>(
                    <li key={i}>
                      <div className=" flex gap-2 bg-gray-100 p-2 rounded-md" onClick={()=>{
                        navigate(`/products/${d._id}`)
                        setSearchQuery("")
                        }}>
                        <div className=" w-10 h-10"><img src={d.images[0]} alt={i} className=" w-full h-full" /></div>
                        <div>
                        <h3 className=" text-[12px]">{d.name}</h3>
                        <h5 className=" text-[10px] font-semibold text-red-600">&#8377; {d.salePrice}</h5>
                        </div>
                      </div>
                    </li>)
                  ):<li className=" text-[12px] w-full">No products found</li>}
                </ul>}
              </div>
            )}
      <div className=" hidden md:block border-t border-b bg-white border-gray-300 py-2 w-full sticky top-0 self-center z-10" onMouseLeave={() => setCatView(false)}>
        <ul className=" flex justify-center items-center text-[12px] font-semibold cursor-pointer gap-5 text-gray-700">
          {categories.map((cate, index) => (
            <li
              className="  hover:text-primary duration-200 ease-in hidden sm:block"
              onMouseEnter={() => {
                setActiveCategoryIndex(index);
                setCatView(true);
              }}
              onTouchStart={() => {
                setActiveCategoryIndex(index);
                setCatView((prev) => !prev);
              }}
              onClick={() => navigate(`/category/${cate}`)}
            >
              {cate}
            </li>
          ))}
        </ul>
        {catView && (
          <div className="absolute left-0 right-0 top-full bg-white shadow-xl p-2 rounded-bl-md rounded-br-md w-full z-50 flex">
            <div className="w-full px-5 flex overflow-auto max-h-[90vh] text-[10px] gap-1">
              {subCategories?.length > 0
                ? chunkArray(subCategories, Math.ceil(subCategories.length / 10)).map(
                    (chunk, columnIndex) => (
                      <div
                        key={columnIndex}
                        className="flex-1 p-2"
                        style={{
                          backgroundColor: columnIndex % 2 === 0 ? '#f2f1f0' : '#fffff', // Light gray and light blue
                        }}
                      >
                        {chunk.map((sub) => (
                          <div key={sub?.name} className="break-inside-avoid mb-4">
                            <h4
                              className="font-semibold text-gray-800 cursor-pointer hover:text-primary"
                              onClick={() =>
                                navigate(
                                  `/category/${categories[activeCategoryIndex]}/${sub.name}`
                                )
                              }
                            >
                              {sub.name}
                            </h4>
                            <ul className="ml-2 mt-1 space-y-1 text-gray-600">
                              {sub?.types?.map((item, index) => (
                                <li
                                  key={index}
                                  className="hover:text-primary cursor-pointer"
                                  onClick={() =>
                                    navigate(
                                      `/category/${categories[activeCategoryIndex]}/${sub.name}/${item.name}`
                                    )
                                  }
                                >
                                  {item.name}
                                </li>
                              ))}
                            </ul>
                          </div>
                        ))}
                      </div>
                    )
                  )
                : 'No data found'}
            </div>
          </div>
        )}

      </div>
      

      <div className="fixed bottom-0 left-0 right-0 z-50 bg-white shadow-2xl md:hidden">
        <div className="flex items-center relative justify-around py-3">
          {menuItems.map((item) => (
            <Link
              key={item.name}
              to={item.href}
              onClick={() => handleLinkClick(item.href)} // Update active link on click
              className={`flex flex-col items-center text-sm font-medium text-gray-800 transition-all ease-in-out duration-300 ${
                activeLink === item.href
                  ? "text-primary "
                  : "text-gray-500 hover:text-primary"
              }`} // Change color for mobile active state
            >
              {item.icon}
              <span className="text-xs mt-1">{item.name}</span>
              {/* {item.name === "Cart" && cartCount > 0 && (
                    <span className="ml-6 absolute inline-flex top-1 items-center justify-center w-5 h-5 text-white bg-primary rounded-full text-xs">
                      {cartItems.length}
                    </span>
                  )} */}
              {/* {item.name === "Orders" && orderCount > 0 && (
                    <span className="ml-6 absolute inline-flex top-1 items-center justify-center w-5 h-5 text-white bg-primary rounded-full text-xs">
                      {orderCount}
                    </span>
                  )} */}
            </Link>
          ))}
        </div>
      </div>
      {/* <div className=" fixed right-0 bg-primary text-white text-xl w-10 h-10 top-1/2 flex justify-center items-center rounded-full shadow-md z-50"> <FaCodeCompare/> <span className=" absolute text-sm -left-1 bg-black text-white w-5 h-5 justify-center items-center flex rounded-full text-[10px] -top-1">{compares?.length}</span></div> */}

      {menuOpen &&
      <SideBar onClose={()=>setMenuOpen(false)}/>}
    </>
  );
};

export default Header;

